import React from 'react'
import { useTranslation } from 'react-i18next'
import HeaderOld from '../../containers/header-old/HeaderOld'
export const NotFound: React.FC = () => {
  const { t } = useTranslation('dashboard')
  return (
    <>
      <HeaderOld />
      <div className='utility-page-wrap w-row'>
        <div className='utility-page-wrap-left'>
          <img src='images/Designs.png' alt='' className='image-42' />
        </div>
        <div className='utility-page-content utility-page-wrap-right'>
          <h2 className='heading-8'>{t('notFound.title')}</h2>
          <div className='div-block-6'>{t('notFound.body')}</div>
        </div>
      </div>
    </>
  )
}
